import { useEffect, useMemo, useState } from "react";
import ReactPaginate from "react-paginate";
import Questions from "./Questions";
import { Wrapper } from "./Questions.style";
import DropDown from "../DropDown/DropDown";
import Loader from "../Loading/Loader";
import RenderLatex from "./RenderLatex";

function AllQuestion(props) {
  const questionPerScreen = 5;
  const [currentScreen, setCurrentScreen] = useState(1);
  const [pageCount, setPageCount] = useState(0);
  const {
    topicId,
    topicQuestion,
    handleDeleteQuestion,
    handleUpdateQuestion,
    filterBy,
    render,
    loading,
  } = props;
  const [formData, setFormData] = useState({ cognitive: "", difficulty: "" });
  const [FilterQuestions, setFilterQuestions] = useState([]);

  useEffect(() => {
    setFormData({ cognitive: "", difficulty: "" });
    setCurrentScreen(1);
  }, [topicId, render]);

  useEffect(() => {
    setFilterQuestions(topicQuestion);
  }, [topicQuestion]);

  useEffect(() => {
    if (formData.cognitive || formData.difficulty || filterBy) {
      let temp = topicQuestion;
      if (formData.cognitive) {
        temp = temp.filter((item) => item.cognitive === formData.cognitive);
      }
      if (formData.difficulty) {
        temp = temp.filter((item) => item.difficulty === formData.difficulty);
      }
      if (filterBy) {
        temp = temp.filter((item) =>
          item.question.toLowerCase().includes(filterBy.toLowerCase())
        );
        setCurrentScreen(1);
      }
      setFilterQuestions(temp);
    } else {
      setFilterQuestions(topicQuestion);
    }
  }, [formData, filterBy]);

  useEffect(() => {
    setPageCount(Math.ceil(FilterQuestions.length / questionPerScreen));
  }, [FilterQuestions]);

  const changePage = ({ selected }) => {
    //console.log(selected);
    setCurrentScreen(selected + 1);
  };

  const questionLists = useMemo(() => {
    return FilterQuestions.slice(
      (currentScreen - 1) * questionPerScreen,
      currentScreen * questionPerScreen
    );
  }, [FilterQuestions, currentScreen]);

  useEffect(() => {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
  }, [currentScreen]);

  return (
    <div>
      {loading ? (
        <Loader type="spin" color="cyan" />
      ) : (
        <Wrapper>
          <div className="headingAssesment">
            <div className="child">
              <div className="totalQuestion">
                <div>Q</div>
                {FilterQuestions.length}
              </div>
              {props.assessmentType !== "competency" ? (
                <div className="filter">
                  <DropDown
                    options={[
                      "knowledge",
                      "analysis",
                      "understanding",
                      "application",
                    ]}
                    name="cognitive"
                    formData={formData}
                    setFormData={setFormData}
                    placeholder="Cognitive"
                  />
                  <DropDown
                    options={["easy", "intermediate", "hard"]}
                    name="difficulty"
                    formData={formData}
                    setFormData={setFormData}
                    placeholder="Difficulty"
                  />
                </div>
              ) : (
                <></>
              )}
            </div>
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <ReactPaginate
              previousLabel={"Previous"}
              nextLabel={"Next"}
              pageCount={pageCount}
              onPageChange={changePage}
              containerClassName={"paginationBttns"}
              previousLinkClassName={"previousBttn"}
              nextLinkClassName={"nextBttn"}
              disabledClassName={"paginationDisabled"}
              activeClassName={"paginationActive"}
              pageRangeDisplayed={1}
              marginPagesDisplayed={1}
              forcePage={currentScreen - 1}
            />
          </div>
          <div>
            {questionLists.map((item, idx) => {
              return (
                <>
                  <Questions
                    handleDeleteQuestion={handleDeleteQuestion}
                    id={item._id}
                    key={item._id}
                    handleUpdateQuestion={handleUpdateQuestion}
                    {...item}
                    no={(currentScreen - 1) * questionPerScreen + idx + 1}
                    assessmentType={props.assessmentType}
                  />
                  {idx === questionLists.length - 1 ? (
                    <RenderLatex render={questionLists} />
                  ) : null}
                </>
              );
            })}
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <ReactPaginate
              previousLabel={"Previous"}
              nextLabel={"Next"}
              pageCount={pageCount}
              onPageChange={changePage}
              containerClassName={"paginationBttns"}
              previousLinkClassName={"previousBttn"}
              nextLinkClassName={"nextBttn"}
              disabledClassName={"paginationDisabled"}
              activeClassName={"paginationActive"}
              pageRangeDisplayed={1}
              marginPagesDisplayed={1}
              forcePage={currentScreen - 1}
            />
          </div>
          {/* <Pagination count={10} color="primary" /> */}
        </Wrapper>
      )}
    </div>
  );
}

export default AllQuestion;
